import { ProductUserViewEnum } from "@saleor/types/globalTypes";

import { ProductsUser } from "../customTypes/ProductsUser";
import {
  KAMSProductUrlQueryParams,
  ProductUrlQueryParams,
  productVariantAddUrl
} from "../urls";

export default function getProductVariantAddUrlByUserType(
  productUser: ProductsUser,
  productId: string,
  params: KAMSProductUrlQueryParams | ProductUrlQueryParams
): string {
  if (productUser.isKAMS && "viewAs" in params) {
    return productVariantAddUrl(productId, {
      brand: params.brand,
      viewAs: params.viewAs as ProductUserViewEnum,
      ...(productUser.isStoreAdmin && {
        mallId: params.mallId,
        tenant: params.tenant
      })
    });
  }
  return productVariantAddUrl(productId);
}
